/*
 * @providesModule PlayerLevelCell
 */
import React from 'react';
import {Text, TouchableOpacity, View, ViewStyle} from 'react-native';
import {_m} from 'INTL';
import CircleProgressLevel, {ICircleProgressLevelProps} from './CircleProgressLevel';
import styles, {PLACEHOLDER_OPACITY} from './PlayerLevelCell.style';

export const TEST_IDS = {
  PLAYER_LEVEL_CELL:'player_level_cell',
  PLAYER_LEVEL_CELL_TITLE:'player_level_cell_title',
  PLAYER_LEVEL_CELL_SUBTITLE:'player_level_cell_subtitle',
};

export interface IPlayerLevelCellProps extends ICircleProgressLevelProps{
  /** The style of the container (optional) */
  styleContainer?:ViewStyle;
  /** The title */
  title?:string;
  /** The subtitle */
  subtitle?:string;
  /** Callback when the cell is pressed */
  onPress?:()=>void;
}

const getAccessibilityLabel = ({title, subtitle, levels}:Pick<IPlayerLevelCellProps, 'title'|'subtitle'|'levels'>) => {
  if (!levels || levels.length === 0) {
    if (!!title && !!subtitle) {
      return _m('{0} {1}', title, subtitle);
    }
    return title || subtitle || _m('Empty player level');
  }
  const lastLevel = levels[levels.length - 1];
  return _m('{0} {1}. Level {2}, {3}% completed.', title, subtitle, lastLevel.level, Math.floor(lastLevel.percentage));
};

const PlayerLevelCell = ({testID, 
  styleContainer, 
  title, 
  subtitle,  
  onPress, 
  ...circleProgressLevelProps}:IPlayerLevelCellProps) => {

  return (
    <TouchableOpacity testID={testID || TEST_IDS.PLAYER_LEVEL_CELL} 
                      style={[styleContainer,
                        {opacity:(!title && !circleProgressLevelProps.levels) ? PLACEHOLDER_OPACITY : 1}]}
                      onPress={onPress}
                      disabled={!onPress}
                      accessibilityLabel={getAccessibilityLabel({title, subtitle, levels:circleProgressLevelProps.levels})}>
      <CircleProgressLevel {...circleProgressLevelProps}/>
      {(!!title || !!subtitle) &&
            <View style={[styles.labelContainer, {maxWidth:circleProgressLevelProps.size}]}>
              {!!title && 
                <Text testID={TEST_IDS.PLAYER_LEVEL_CELL_TITLE} 
                      style={styles.title}
                      numberOfLines={2}>
                  {title}
                </Text>
              }
              {!!subtitle &&
                <Text testID={TEST_IDS.PLAYER_LEVEL_CELL_SUBTITLE} 
                      style={styles.subtitle}>
                  {subtitle}
                </Text>
              }
            </View>
      }
      
    </TouchableOpacity>
  );
};

export default PlayerLevelCell;
